import { VariantAttributeScope } from "@the-volte/svc-core-sdk";
import { GetServerSideProps } from "next";

import { channelSlug } from "@temp/constants";
import { PurchaseStatusEnum } from "@types";
import { getSaleorApi } from "@utils/ssr";

import { ProductPage, ProductPageProps } from "../../views/Product";

export default ProductPage;

export const getServerSideProps: GetServerSideProps<
  ProductPageProps,
  ProductPageProps["params"]
> = async ({ params }) => {
  const { api } = await getSaleorApi();
  const { data } = await api.products.getDetails({
    slug: params?.slug,
    channel: channelSlug,
    variantSelection: VariantAttributeScope.VARIANT_SELECTION,
  });

  const showRecommendations =
    Boolean(data?.isb) ||
    Boolean(data?.isDeleted) ||
    data?.purchaseStatus === PurchaseStatusEnum.PENDING ||
    data?.purchaseStatus === PurchaseStatusEnum.SOLD;

  if (!data || data?.isDeleted) return { notFound: true };

  return {
    props: {
      data: data || null,
      params,
      showRecommendations,
    },
  };
};
